import { z } from 'zod';
import { commercialModelSchema, currencySchema, moneySchema, projectScopeSchema, projectWorkTypeSchema, } from './common.js';
export const clientTrackingInputSchema = z.discriminatedUnion('mode', [
    z.object({ mode: z.literal('automatic') }),
    z.object({ mode: z.literal('manual'), enabled: z.boolean() }),
]);
export const projectTrackingInputSchema = z.object({ override: z.boolean().nullable() });
export const projectSignatureInputSchema = z.object({ contractSigned: z.boolean() });
export const projectSoldAverageRateOverrideInputSchema = z.discriminatedUnion('mode', [
    z.object({ mode: z.literal('clear') }),
    z.object({
        mode: z.literal('set'),
        amountMinor: z.number().int().positive().max(10_000_000),
        currency: currencySchema,
        reason: z.string().trim().min(1).max(500),
    }),
]);
export const projectContractStatusSchema = z.object({
    contractSigned: z.boolean(),
    productionStarted: z.boolean(),
});
const completeMoneySchema = moneySchema.extend({
    complete: z.boolean(),
    missingRateEntryCount: z.number().int().nonnegative(),
});
const portfolioAverageRecoveryRateSchema = z.object({
    averageRecoveryRate: moneySchema.nullable(),
    complete: z.boolean(),
});
const portfolioFinancialsSchema = z.object({
    yearRevenue: completeMoneySchema,
    monthRevenue: completeMoneySchema,
    averageRecoveryRate: portfolioAverageRecoveryRateSchema,
});
export const portfolioInsightsSchema = z.object({
    scope: projectScopeSchema,
    currency: currencySchema,
    period: z.object({
        yearStart: z.iso.date(),
        yearEnd: z.iso.date(),
        monthStart: z.iso.date(),
        monthEnd: z.iso.date(),
    }),
    financials: portfolioFinancialsSchema.nullable(),
    capacityCoverageBasisPoints: z.number().int().nonnegative().nullable(),
    remainingMinutes: z.number().int().nonnegative(),
    projects: z.array(z.object({
        id: z.uuid(),
        clientName: z.string(),
        name: z.string(),
        status: z.enum(['planning', 'active', 'paused', 'completed', 'archived']),
        contractSigned: z.boolean(),
        endDate: z.iso.date().nullable(),
        remainingMinutes: z.number().int().nonnegative(),
        financials: portfolioFinancialsSchema.nullable(),
    })),
});
export const projectSchema = z.object({
    id: z.uuid(),
    clientId: z.uuid(),
    key: z.string().min(1).max(64),
    name: z.string().min(1).max(240),
    currency: currencySchema,
    status: z.enum(['planning', 'active', 'paused', 'completed', 'archived']),
    workType: projectWorkTypeSchema.optional(),
    commercialModel: commercialModelSchema.nullable().optional(),
    startDate: z.iso.date().nullable(),
    endDate: z.iso.date().nullable(),
    contractSigned: z.boolean(),
    productionStarted: z.boolean(),
    teamNames: z.array(z.string()).default([]),
    soldAverageRateOverride: moneySchema.nullable(),
});
//# sourceMappingURL=portfolio.js.map